export const generateDateFormat = (date) => {
  const formattedDate = `${new Date(date).getFullYear()}-${String(
    new Date(date).getMonth() + 1
  ).padStart(2, "0")}-${String(new Date(date).getDate()).padStart(2, "0")}`;
  return formattedDate;
};
